module.exports = {"TXTWCL_Verdict":{"id":"TXTWCL_Verdict","defaultMessage":"Vainqueur pronostiqué"}}